<template>
  <div class="footer">
    <div class="mdc-layout-grid">
      <footer class="mdc-layout-grid__inner">
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-desktop"
        >
          <div class="footer__logo-container">
            <SvgBubblemapsLogo class="footer__logo" />
            <SvgBubblemapsText class="footer__logotext" />
          </div>
          <div class="footer__subtitle">The Blockchain Analytics Layer</div>
          <div class="footer__socials">
            <a target="_blank" href="https://twitter.com/bubblemaps">
              <SvgTwitterLogo class="footer__social" />
            </a>
            <a target="_blank" href="https://t.me/bubblemaps">
              <SvgTelegramLogo class="footer__social" />
            </a>
            <a target="_blank" href="https://discord.gg/Sm6PJxwaqy">
              <SvgDiscordLogo class="footer__social footer__social--discord" />
            </a>
            <a target="_blank" href="https://www.instagram.com/bubblemaps.io/">
              <SvgInstagramLogo
                class="footer__social footer__social--instagram"
              />
            </a>
            <a target="_blank" href="https://www.youtube.com/c/Bubblemaps/">
              <SvgYoutubeLogo class="footer__social" />
            </a>
          </div>
          <div class="footer__bmt">
            <span>$BMT</span>
            <br />
            <img src="@/assets/logos/exchanges/binance.png" />
            <img src="@/assets/logos/exchanges/bithumb.png" />
            <img src="@/assets/logos/exchanges/bybit.png" />
            <img src="@/assets/logos/exchanges/kraken.png" />
            <img src="@/assets/logos/exchanges/bitget.png" />
            <div>
              <img src="@/assets/logos/exchanges/cryptocom.png" />
              <img src="@/assets/logos/exchanges/kucoin.png" />
              <img src="@/assets/logos/exchanges/gateio.png" />
              <img src="@/assets/logos/exchanges/mexc.png" />
            </div>
          </div>
          <div class="footer__policies --left">
            <div>
              Donations:
              <a
                target="_blank"
                href="https://etherscan.io/address/0x6710451bb62bEc1e546ec31bCb591aD61c6b19D5"
              >
                0x6710...19d5
              </a>
              ♥
            </div>
            <div>
              <a
                target="_blank"
                href="https://bubblemaps.notion.site/Bubblemaps-Terms-Conditions-6b2610c5432b48fc932cfa859ab33ecf"
              >
                Terms & Conditions
              </a>
              -
              <a
                target="_blank"
                href="https://bubblemaps.notion.site/Bubblemaps-Cookie-Preferences-1cb5871e572045c9be29fa26850a0d90"
              >
                Cookies
              </a>
              -
              <a
                target="_blank"
                href="https://bubblemaps.notion.site/Bubblemaps-Privacy-Policy-676d478607c449a0a57fed194e45c1f4"
              >
                Privacy
              </a>
            </div>
            <div class="footer__policies__copyright">
              © {{ new Date().getFullYear() }} Bubblemaps SAS. All Rights
              Reserved.
            </div>
          </div>
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-2-desktop"
        >
          <h5>Product</h5>
          <router-link to="/v2">Bubblemaps V2</router-link>
          <router-link to="/intel-desk">Intel Desk</router-link>
          <a target="_blank" href="https://pro.bubblemaps.io/api/plans">
            API
          </a>
          <router-link to="/case-studies">Case Studies</router-link>
          <router-link to="/work-with-us">Integrate Us</router-link>
          <a
            target="_blank"
            href="https://docs.google.com/forms/d/e/1FAIpQLSdj9s9DhslOWlgv1xaJRlOAAv-3lYOzR7W9IWpnv0v0b2EFog/viewform"
          >
            Get Listed
          </a>
          <a target="_blank" href="https://blog.bubblemaps.io/">Blog</a>
          <a target="_blank" href="https://wiki.bubblemaps.io/bmt">BMT</a>
          <a
            target="_blank"
            href="https://company-236917.frontify.com/d/g3AFoWSwxiY1/logo-pngs"
            >Brand Kit</a
          >
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-2-desktop"
        >
          <h5>
            Supported<br />
            Chains
          </h5>
          <a target="_blank" href="https://v2.bubblemaps.io/bsc">BNB Chain</a>
          <a target="_blank" href="https://v2.bubblemaps.io/eth">Ethereum</a>
          <a target="_blank" href="https://v2.bubblemaps.io/solana">Solana</a>
          <a target="_blank" href="https://v2.bubblemaps.io/base">Base</a>
          <a target="_blank" href="https://v2.bubblemaps.io/tron">Tron</a>
          <a target="_blank" href="https://v2.bubblemaps.io/ton">TON</a>
          <a target="_blank" href="https://v2.bubblemaps.io/sonic">Sonic</a>
          <a target="_blank" href="https://v2.bubblemaps.io/monad">Monad</a>
          <a target="_blank" href="https://v2.bubblemaps.io/polygon">Polygon</a>
          <a target="_blank" href="https://v2.bubblemaps.io/avalanche"
            >Avalanche</a
          >
          <a target="_blank" href="https://v2.bubblemaps.io/aptos">Aptos</a>
          <a target="_blank" href="https://v2.bubblemaps.io/arbitrum"
            >Arbitrum</a
          >
          <a target="_blank" href="https://v2.bubblemaps.io/hyperevm"
            >HyperEVM</a
          >
          <a target="_blank" href="https://v2.bubblemaps.io/robinhood"
            >Robinhood</a
          >
          <a target="_blank" href="https://v2.bubblemaps.io/arc">Arc</a>
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-2-desktop"
        >
          <h5>Integrations</h5>
          <a target="_blank" href="https://etherscan.io/">Etherscan</a>
          <a target="_blank" href="https://www.coingecko.com/">CoinGecko</a>
          <a target="_blank" href="https://pro.opensea.io/">OpenSea</a>
          <a target="_blank" href="https://dexscreener.com/">DEX Screener</a>
          <a target="_blank" href="https://www.geckoterminal.com/"
            >GeckoTerminal</a
          >
          <a target="_blank" href="https://pump.fun/">Pump.fun</a>
          <a target="_blank" href="https://dyorlabs.com/">DYOR Labs</a>
          <a target="_blank" href="https://www.dextools.io/app/">DEXTools</a>
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-2-desktop"
        >
          <h5>Contact</h5>
          <a target="_blank" href="https://discord.gg/Sm6PJxwaqy">Discord</a>
          <a target="_blank" href="https://t.me/Bubblemaps_BD">Telegram</a>
          <a target="_blank" href="mailto:api@bubblemaps.io">API & iFrames</a>
          <a target="_blank" href="mailto:press@bubblemaps.io">Press</a>
          <a target="_blank" href="https://discord.gg/Sm6PJxwaqy">Support</a>
          <a target="_blank" href="mailto:contact@bubblemaps.io">Other</a>
          <a target="_blank" href="https://wiki.bubblemaps.io/our-team">Team</a>
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 footer__policies --bottom"
        >
          <div>
            <div>
              Donations:
              <a
                target="_blank"
                href="https://etherscan.io/address/0x6710451bb62bEc1e546ec31bCb591aD61c6b19D5"
              >
                0x6710...19d5
              </a>
              ♥
            </div>
            <a
              target="_blank"
              href="https://bubblemaps.notion.site/Bubblemaps-Terms-Conditions-6b2610c5432b48fc932cfa859ab33ecf"
            >
              Terms & Conditions
            </a>
            -
            <a
              target="_blank"
              href="https://bubblemaps.notion.site/Bubblemaps-Cookie-Preferences-1cb5871e572045c9be29fa26850a0d90"
            >
              Cookies
            </a>
            -
            <a
              target="_blank"
              href="https://bubblemaps.notion.site/Bubblemaps-Privacy-Policy-676d478607c449a0a57fed194e45c1f4"
            >
              Privacy
            </a>
          </div>
          <div class="footer__policies__copyright">
            © {{ new Date().getFullYear() }} Bubblemaps SAS. All Rights
            Reserved.
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped lang="scss">
@import "src/assets/variables";

.footer {
  background-color: $theme-almost-black;
  color: $theme-light-grey;
  font-size: 0.8rem;
  padding-top: 60px;
  padding-bottom: 40px;
  a {
    margin-bottom: 8px;

    &:hover {
      color: $theme-blue;
    }
  }

  .mdc-layout-grid__cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  h5 {
    margin-top: 0;
    color: white;
    margin-bottom: 10px;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 1.1em;
  }
}

.footer__subtitle {
  text-transform: uppercase;
  letter-spacing: 0.15rem;
  font-size: 0.75rem;
}

.footer__socials {
  margin-top: 12px;
  display: flex;
  align-items: center;

  a {
    background-color: rgba($theme-blue, 0.3);
    transition: background-color 150ms linear;
    width: 35px;
    height: 35px;
    margin-right: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;

    .footer__social {
      height: 24px;
      fill: white;

      &.footer__social--instagram {
        height: 20px;
      }

      &.footer__social--discord {
        height: 18px;
        position: relative;
        top: -1px;
      }

      &.footer__social--email {
        height: 22px;
      }
    }

    &:hover {
      background-color: $theme-blue;
    }
  }
}

.footer__bmt {
  margin: 8px 0;
  span {
    font-weight: 700;
    font-size: 1.2em;
    color: white;
    background-color: rgba($theme-pink, 0.3);
    padding: 3px 6px;
    border-radius: 4px;
  }

  img {
    height: 22px;
    margin-left: 5px;
    border-radius: 100px;
    border: 1px solid rgba(white, 0.2);
    vertical-align: bottom;
    margin-top: 8px;
  }

  div {
    display: inline-block;
  }
}

@media (min-width: $mdc-grid-desktop) {
  .footer__bmt {
    margin: 0;
    br {
      display: none;
    }
  }
}

.footer__policies {
  margin-top: 10px;
  opacity: 0.7;
  font-size: 0.9em;

  &.--left {
    display: none;
  }

  .footer__policies__copyright {
    margin-top: 10px;
    font-size: 0.9em;
    opacity: 0.7;
  }
}

.footer__logo-container {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .footer__logo {
    height: 20px;
  }
  .footer__logotext {
    height: 20px;
    margin-left: 10px;
    position: relative;
    top: 1px;
    fill: white;
  }
}

@media (min-width: $mdc-grid-desktop) {
  .footer {
    .mdc-layout-grid__cell {
      align-items: flex-start;
      text-align: left;
    }
  }

  .footer__policies {
    &.--left {
      display: initial;
    }

    &.--bottom {
      display: none;
    }
  }
}

@media (min-width: $mdc-desktop) {
  .footer {
    font-size: 0.9rem;
  }
}
</style>
